import Lowlight from "react-lowlight";
// @ts-expect-error - highlight.js library doesn't have type definitions
import json from "highlight.js/lib/languages/json";
// @ts-expect-error - highlight.js library doesn't have type definitions
import markdown from "highlight.js/lib/languages/markdown";
import "highlight.js/styles/github.css";

export const initializeLowlight = () => {
  Lowlight.registerLanguage("json", json);
  Lowlight.registerLanguage("markdown", markdown);
};
